export default {
    municipalityFilter: {
        paddingBottom: '1.5rem',
        paddingRight: '1rem',
        maxWidth: '270px',
        paddingTop: '5px',
    },
};
